import { useLocation } from 'react-router-dom';

import isActivePath from '../isActivePath';
import { SideMenuDropdown } from '../types';
import DropdownFlyout from './dropdownFlyout';
import DropdownInline from './dropdownInline';

interface Props {
	dropdown: SideMenuDropdown;
	showLabel: boolean;
}

/**
 * Picks the dropdown presentation: inline (expanded menu) or a flyout anchored
 * to the icon (collapsed rail). Both highlight the header when a child route is
 * active.
 */
const DropdownGroup = ({ dropdown, showLabel }: Props) => {
	const { pathname } = useLocation();
	const containsActive = dropdown.pages.some((page) => isActivePath(pathname, page.path));

	if (!showLabel) {
		return <DropdownFlyout dropdown={dropdown} active={containsActive} />;
	}

	return (
		<DropdownInline dropdown={dropdown} initiallyOpen={containsActive} active={containsActive} />
	);
};

export default DropdownGroup;
